import { TAGS } from "../constants";
import { Treatment, TreatmentCreate } from "../types";
import { api } from "./api";

export const treatmentsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTreatments: builder.query<Treatment[], void>({
      query: () => ({
        method: "GET",
        url: `/api/treatments`,
      }),
      providesTags: [TAGS.TREATMENTS],
    }),
    createTreatment: builder.mutation<Treatment, TreatmentCreate>({
      query: (body) => ({
        method: "POST",
        url: `/api/treatments`,
        body,
      }),
      invalidatesTags: [TAGS.TREATMENTS],
    }),
  }),
});

export const { useGetTreatmentsQuery, useCreateTreatmentMutation } =
  treatmentsApi;
